import React, { useState } from 'react';
import './index.h5.less';

import { Button, PopupSwiper, Toast } from '@arco-design/mobile-react-serial-i18n';
import { Tea } from '@utils/tea';
import { EVENTS } from '@constants/event';
import Reasons, { ReasonItem, useReasonData } from './reasons';
import ScoreBoard from './score-board';
import { OtherTextMap, PopupTitleMap, ScoreLevels } from './constants';
import Divider from '@components/divider';
import { reportClassScore } from '@service/api';
import { useArticle, useUserInfo } from '@utils/hooks';
import { useTranslation } from '@ies/intl-react-plugin';

interface IProps {
    articleId: string;
}

const Score: React.FC<IProps> = ({ articleId }) => {
    const [score, setScore] = useState<ScoreLevels>();
    const [visible, setVisible] = useState(false);
    const [reasons, setReasons] = useState<ReasonItem[]>([]);
    const [suggestion, setSuggestion] = useState('');
    const [hasSubmit, setHasSubmit] = useState(false);

    const { t } = useTranslation();
    const { id } = useUserInfo();
    const { hasClassCore, title } = useArticle();
    const reasonData = useReasonData();

    const noSuggestion = reasons.some(item => item.needSuggestion) && !suggestion.trim();

    const submitScore = () => {
        try {
            const reason = reasons.map(({ key }) => t(key, key)).join(',');
            Tea(EVENTS.ACADEMY_RATING, {
                reason,
                article_id: articleId,
                rating: score,
                academy_name: title,
                detail: suggestion,
            });

            reportClassScore({
                reason,
                item_id: articleId,
                score: score || ScoreLevels.Level1,
                suggestion,
            });

            setHasSubmit(true);
        } catch (e) {}
    };

    const resetReason = () => {
        setReasons([]);
        setSuggestion('');
    };

    if (hasSubmit || hasClassCore || !id) {
        return null;
    }

    return (
        <>
            <Divider />
            <div className="article-score">
                <p className="article-score-title">{t('academy_rating_title')}</p>
                <ScoreBoard
                    selected={score}
                    onClick={v => {
                        setScore(v);
                        resetReason();
                        setVisible(true);
                    }}
                />
                <PopupSwiper
                    className="article-score-popup"
                    visible={visible}
                    close={() => setVisible(false)}
                    title={<div className="article-score-popup-title">{t(PopupTitleMap[score || ''])}</div>}
                    allowSwipeDirections={['bottom']}
                    onClose={submitScore}
                    direction="bottom"
                >
                    <div className="article-score-popup-inner">
                        <ScoreBoard
                            selected={score}
                            onClick={v => {
                                setScore(v);
                                resetReason();
                            }}
                        />
                        <Reasons
                            score={score}
                            reasons={reasons}
                            reasonData={reasonData}
                            setReasons={setReasons}
                            suggestion={suggestion}
                            setSuggestion={setSuggestion}
                        />
                        <Button
                            style={{ marginTop: 36 }}
                            disabled={!reasons.length || noSuggestion}
                            onClick={() => {
                                Toast.info(t('academy_rating_toast'));
                                submitScore();
                                setVisible(false);
                            }}
                            onClickDisabled={() => {
                                if (noSuggestion || !reasons.length) {
                                    Toast.info(t('academy_rating_direction'));
                                }
                            }}
                        >
                            {t('academy_rating_sumbit')}
                        </Button>
                    </div>
                </PopupSwiper>
            </div>
        </>
    );
};
export default Score;
